import React from "react";
import "./Home.css";

const HomePage = () => {
  return (
    <div className="admin-home">
      <div className="welcome-section">
        <h1 className="welcome-title">Welcome to Sentinix Admin Dashboard</h1>
        <p className="welcome-subtitle">Manage your exams, results, and questions efficiently</p>
      </div>

      {/* <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: "#3b82f6" }}>
            <i className="icon">📊</i>
          </div>
          <div className="stat-info">
            <h3>Total Students</h3>
            <p className="stat-number">150</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: "#10b981" }}>
            <i className="icon">📝</i>
          </div>
          <div className="stat-info">
            <h3>Total Exams</h3>
            <p className="stat-number">25</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: "#f59e0b" }}>
            <i className="icon">❓</i>
          </div>
          <div className="stat-info">
            <h3>Questions</h3>
            <p className="stat-number">500</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ backgroundColor: "#8b5cf6" }}>
            <i className="icon">✅</i>
          </div>
          <div className="stat-info">
            <h3>Completed</h3>
            <p className="stat-number">120</p>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="action-buttons">
          <button className="action-btn">
            <span className="btn-icon">➕</span>
            Add New Exam
          </button>
          <button className="action-btn">
            <span className="btn-icon">📋</span>
            View Results
          </button>
          <button className="action-btn">
            <span className="btn-icon">❓</span>
            Manage Questions
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default HomePage;